import { Link } from 'react-router-dom'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
// Hooks
import { getProfile } from 'src/redux/slices/user/endpoints'

import { Divider, Grid, Typography } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import ProfileTextField from '../components/ProfileTextField'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    borderedCell: {
      borderRight: '1px solid gray',
      marginRight: '1rem',
    },
    paragraph: {
      marginTop: '1rem',
    },
  }),
)

///// Component
const UserPage: React.FC = () => {
  const { data: profile } = getProfile.useQuery('', {
    refetchOnMountOrArgChange: true,
  })
  useTabNavigation()
  const classes = useStyles()

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item className={classes.borderedCell}>
          {profile && <ProfileTextField profile={profile} field='name' label='Name' />}
          <Typography variant='h5'>Email</Typography>
          <Grid container alignItems='center'>
            <Grid item>
              <Typography>{profile?.email}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Typography variant='h5'>Welcome!</Typography>
          <Typography className={classes.paragraph}>
            Welcome to the new UBEM.io. UBEM.io now has an account-based system for you to track
            your projects and save your work over time, making it easier to share results and
            quickly test technology pathways for your UBEM.
          </Typography>
          <Typography className={classes.paragraph}>
            To get started, head over to the <Link to='/account/teams'>Teams</Link> tab.
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}

export default UserPage
